import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/no_data1.png'


const _withScopeId = n => (_pushScopeId("data-v-13a2f378"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ckb-choice-detail"
}
const _hoisted_2 = {
  key: 0,
  class: "choice-detail-link flex-ter"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 8px"} }, "/", -1))
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "product-info flex" }
const _hoisted_6 = { class: "product-info-content" }
const _hoisted_7 = { class: "product-name" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = { class: "size" }
const _hoisted_10 = { class: "size-item" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = {
  key: 0,
  class: "size-item"
}
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = {
  key: 1,
  class: "size-item"
}
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = {
  key: 2,
  class: "size-item"
}
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = { class: "product-info-btn" }
const _hoisted_23 = { class: "product-list" }
const _hoisted_24 = {
  key: 1,
  class: "text-ct code-error"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-data-code-error",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-ct" }, "このページではアクセスがサポートされていません。", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]

import { t } from '@/plugins/i18n'
import { getProductAtlasApi, addWishListApi, removeWishListApi } from '@/apis/goods'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useRtfix } from '@/store'
import { ElMessage as message } from 'element-plus'
import { useStore } from 'vuex'
import Image from '@/components/common/Image.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const info: any = ref({})
const showLink = ref(false)
const isWarning = ref(false)
const back = () => {
  history.go(-1)
}
onMounted(() => {
  if (!store.getters.isLogin) {
    message.warning(t('ご利用を続行するには、アカウントをログインして下さい'))
    router.push('/')
    return
  }
  showLink.value = !!route.query.haveLink
  getDetail()
})
const getDetail = async () => {
  const { data, success } = await getProductAtlasApi({
    atlasCode: route.params.code,
    superCustomerId: store.getters.user?.superCustomerId,
    customerShopId: store.state.route.curShop
  })
  if (!success) {
    isWarning.value = true
  }
  info.value = data
}
const addWish = async () => {
  const { success } = await addWishListApi({
    atlasCode: route.params.code
  })
  if (success) {
    message.success(t('加入心愿单成功！'))
    getDetail()
  }
}
const cancelAddWish = async () => {
  const { success } = await removeWishListApi({
    atlasCode: route.params.code
  })
  if (success) {
    message.success(t('成功取消添加心愿单'))
    getDetail()
  }
}

return (_ctx: any,_cache: any) => {
  return (!isWarning.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (showLink.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                class: "cursor-pt",
                onClick: back
              }, _toDisplayString(_unref(t)('所有选品图集')), 1),
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, "PRODUCT# " + _toDisplayString(info.value.atlasCode), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "product-info-img",
            style: _normalizeStyle({ backgroundImage: `url(${info.value.headerImage})` })
          }, null, 4),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, "PRODUCT# " + _toDisplayString(info.value.atlasCode), 1),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.labels, (item) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: item.id
                }, _toDisplayString(item.labelNameJp), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('商品编码')) + "：", 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, _toDisplayString(info.value.atlasCode ?? '-'), 1)
                ])
              ]),
              (info.value.productPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('价格区间')) + "：", 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", null, _toDisplayString(info.value.productPrice.map(v => `${v?.priceDesc ?? ''} ${v.priceStart}-${v.priceEnd}`).join(',')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (info.value.productSpece)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('规格')) + "：", 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", null, _toDisplayString(info.value.productSpece ?? '-'), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (info.value.minOrderQuantity)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('起订量')) + "：", 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", null, _toDisplayString(info.value.minOrderQuantity) + _toDisplayString(_unref(t)('件')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (info.value.addWishFlag === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn1",
                  onClick: cancelAddWish
                }, _toDisplayString(_unref(t)('取消加入心愿单')), 1))
              : _createCommentVNode("", true),
            (info.value.addWishFlag === 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn1",
                  onClick: addWish
                }, _toDisplayString(_unref(t)('加入心愿单')), 1))
              : _createCommentVNode("", true),
            (info.value.productCode)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "btn2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('goods', { params: { id: info.value.productCode } }))))
                }, _toDisplayString(_unref(t)('立即购买')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.productImgs, (v, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "prodcut-img",
              key: index
            }, [
              _createVNode(Image, {
                src: v + (v.includes('theckb') ? `?x-oss-process=image/resize,w_${800},limit_0,/format,webp` : ''),
                fit: "cover",
                class: "img",
                "preview-src-list": info.value.productImgs,
                "initial-index": index
              }, null, 8, ["src", "preview-src-list", "initial-index"])
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
}
}

})